import MuiGrid from '@mui/material/Grid';
import { forwardRef } from 'react';
import type { ReactNode } from 'react';
import { toVendor } from '../styles';
import type { Breakpoint, Space, Styleable } from '../styles';

/**
 * The twelve-column grid.
 *
 * The public shape here is `size={{ xs: 12, md: 6 }}`.
 *
 * It was `item xs={12} md={6}` at 192 call sites when this file was written, and
 * the vendor then removed that spelling. Those 192 call sites did not change: the
 * translation lived here, and when the vendor caught up with the shape this file
 * already exposed, the translation simply went away. This is the argument for the
 * seam, and it is the only file that had to know.
 */

type Columns = number | 'auto' | 'grow';

export interface GridProps extends Styleable {
  container?: boolean;
  size?: Partial<Record<Breakpoint, Columns>>;
  spacing?: Space;
  columnSpacing?: Space;
  rowSpacing?: Space;
  children?: ReactNode;
  key?: string | number;
}

export const Grid = forwardRef<HTMLDivElement, GridProps>(function Grid(
  { container, size, styles, vendorStyles, ...rest },
  ref,
) {
  return (
    <MuiGrid
      ref={ref}
      container={container}
      {...(size ? { size } : {})}
      {...rest}
      sx={toVendor(styles, vendorStyles)}
    />
  );
});
